<template>
  <v-card outlined>
    <v-card-text>
      <v-row
        v-if="users.length > 0"
        class="d-flex"
        :class="
          $vuetify.breakpoint.name !== 'xs'
            ? 'justify-space-between align-center'
            : 'flex-row-reverse'
        "
        dense
      >
        <span v-if="$vuetify.breakpoint.name !== 'xs'" class="list-header">{{
          $t('device.manager')
        }}</span>
        <span
          class="list-header"
          :class="$vuetify.breakpoint.name !== 'xs' ? 'mr-10' : 'mr-10'"
          >{{ $t('device.receiveFaultMails') }}</span
        >
      </v-row>
      <v-row
        class="d-flex justify-space-between align-center"
        dense
        v-for="(user, i) in users"
        :visible="users.length > 0"
        :key="i"
      >
        <span class="user flex-grow-1">{{ user.user | user }}</span>
        <v-checkbox
          class="mt-0"
          style="height: 30px"
          v-model="user.receiveFaultMails"
        ></v-checkbox>
        <v-btn
          icon
          :title="$t('actions.delete')"
          @click="removeUser(user.user)"
        >
          <v-icon>mdi-minus-circle-outline</v-icon>
        </v-btn>
      </v-row>

      <UserSelectField
        :show-select-dialog-button="true"
        :show-add-dialog-button="true"
        :dense="true"
        @change="addUser"
        v-model="userToAdd"
        class="mb-1 mt-1"
        :label="$t('actions.add')"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import UserSelectField from '@/components/inputs/UserSelectField';

export default {
  name: 'MultipleUsersSelectWithEmailNotification',

  components: { UserSelectField },

  props: {
    value: {
      required: true,
      type: Array,
    },
  },

  data: () => ({
    userToAdd: null,
    disabled: false,
  }),

  computed: {
    users: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
  },

  methods: {
    mapToItem(user) {
      return {
        user: user,
        receiveFaultMails: false,
      };
    },

    addUser(user) {
      if (!user) {
        return;
      }

      if (this.users.some((item) => item.user.id === user.id)) {
        this.userToAdd = null;
        return;
      }
      this.users.push({
        user,
        receiveFaultMails: true,
      });
      this.userToAdd = null;
    },

    removeUser(userToRemove) {
      this.users = this.users.filter(
        (item) => item.user.id !== userToRemove.id,
      );
    },
  },
};
</script>

<style>
.list-header {
  font-size: 0.9rem;
  font-weight: 600;
}
.user {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 400;
}
</style>
